import { ReactComponent as PhoneAltIconSVG } from '@/assets/icons/PhoneAltIcon.svg';
import { SVGProps } from 'react';

const PhoneAltIcon = (props: SVGProps<SVGSVGElement>) => <PhoneAltIconSVG {...props} />;

export default PhoneAltIcon;
